import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import AttachFile from '@/components/assets/AttachFile'
import { getFileManagerURL, uploadFilesToAgent } from '@/store/gigiChat/LiveAgentAtom'

import TooBigFileDrawer from './drawer/bigFileDrawer'

const UploadFilesToAgent = ({ handleMessage }: { handleMessage: (question: string, fileURLManager?: Array<string>) => void }) => {
    const { t } = useTranslation()
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const [tooBigFiles, setTooBigFiles] = useState<File[]>([])
    const [fileToUpload, setFileToUpload] = useState<File[]>([])

    useEffect(() => {
        if (fileToUpload.length && tooBigFiles.length === 0 && !isDrawerOpen) {
            const uploadNextFile = async (files: File[]) => {
                if (files.length === 0) {
                    setFileToUpload([])
                    return
                }

                const allFileNames: { fileName: string; gigiFileManagerURL: string }[] = []

                for (const file of files) {
                    const formData = new FormData()
                    formData.append('file', file)

                    const res = await uploadFilesToAgent(formData)
                    if (res?.ok) {
                        const jsonResponse = (await res?.json()) as { gigiFileManagerId?: string }
                        const gigiFileManagerId = jsonResponse?.gigiFileManagerId
                        if (gigiFileManagerId) {
                            const fileManagerRes = await getFileManagerURL(gigiFileManagerId)
                            if (fileManagerRes?.ok) {
                                const fileUrl = (await fileManagerRes.json()) as { sasUrl: string }
                                allFileNames.push({ fileName: file.name, gigiFileManagerURL: fileUrl.sasUrl })
                            }
                        }
                    }
                }

                if (allFileNames.length > 0) {
                    const title = t('userAgent.questionTitle')

                    const gigiFileManagerURL = allFileNames.map((file) => file.gigiFileManagerURL)
                    const files = allFileNames.map((file) => file.fileName).join(', ')
                    handleMessage(title + ' ' + files, gigiFileManagerURL)
                }

                setFileToUpload([])
            }

            void uploadNextFile(fileToUpload)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileToUpload, tooBigFiles, isDrawerOpen, handleMessage])

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const tooBigFiles: File[] = []
        let selectedFiles = event.target.files ? Array.from(event.target.files) : []
        selectedFiles = selectedFiles.filter((file) => {
            if (file.size > 30 * 1024 * 1024) {
                tooBigFiles.push(file)
                return false
            }
            return true
        })

        if (tooBigFiles.length) {
            setTooBigFiles(tooBigFiles)
            setIsDrawerOpen(true)
        }

        if (selectedFiles.length) {
            setFileToUpload(selectedFiles)
        }

        event.target.value = ''
    }

    const onClose = () => {
        setIsDrawerOpen(false)
        setTooBigFiles([])
    }

    return (
        <div>
            <TooBigFileDrawer files={tooBigFiles} isOpen={isDrawerOpen} onClose={onClose} />
            <input type="file" multiple onChange={handleFileChange} style={{ display: 'none' }} id="file-upload" />
            <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                <AttachFile />
            </label>
        </div>
    )
}

export default UploadFilesToAgent
